"use client"

import { AlignVerticalSpaceAround } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AlignVerticalSpaceAroundIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AlignVerticalSpaceAroundIcon = component(Icon)({
  as: AlignVerticalSpaceAround,
})
